import React, { Component } from 'react';

class VideoPlayer extends Component {
  render() {
    const { src, onLoadedMetadata, onError, labelKey } = this.props;
    return (
      <video
        controls
        preload="metadata"
        crossOrigin="anonymous"
        playsInline
        onLoadedMetadata={onLoadedMetadata}
        onError={(e) => onError && onError(labelKey || src, e)}
      >
        <source src={src} type="video/mp4" />
      </video>
    );
  }
}

export default VideoPlayer;
